export const MAX_CHARACTER_LIMIT = 1700;

export const SHORTENED_URL_TOOLTIP_MESSAGE =
  'Mobile carriers block shortened links like this one because it looks like spam. Paste the full web address instead.';
